import { apiClient } from './api.client';

export const CrmService = {
  BusinessJobVacancy,
  GetApplicants,
  GetCompanies,
  GetUsers,
  GetNews,
  delteNewById,
  CreateUsers,
  CreateNews,
  JobpostsExport,
  ApplicantsExport,
};

function JobpostsExport() {
  return apiClient.get('/api/cms/jobposts/export/', {
    headers: {
      Accept: 'vnd.ms-excel',
    },
    responseType: 'blob',
  });
}

function ApplicantsExport() {
  return apiClient.get('/api/cms/applicants/export/', {
    headers: {
      Accept: 'vnd.ms-excel',
    },
    responseType: 'blob',
  });
}

function BusinessJobVacancy(urlTo, params) {
  const url = urlTo || '/api/cms/jobposts/';

  return apiClient.get(url, { params });
}

function GetApplicants(urlTo, params) {
  const url = urlTo || '/api/cms/applicants/';

  return apiClient.get(url, { params });
}

function GetCompanies(urlTo) {
  const url = urlTo || '/company/';

  return apiClient.get(url);
}

function GetUsers() {
  return apiClient.get('/api/cms/users/');
}

function GetNews() {
  return apiClient.get('/api/cms/news/');
}

function delteNewById(id) {
  return apiClient.delete(`/api/cms/news/${id}/`);
}

function CreateUsers(data) {
  return apiClient.post('/api/cms/users/', data);
}

function CreateNews(data) {
  return apiClient.post('/api/cms/news/', data);
}
